import { ShieldAlert, ShieldCheck } from "lucide-react";

const TONE = {
  chosen: "border-emerald-300 bg-white text-emerald-800",
  available: "border-slate-200 bg-white text-slate-600",
  excluded: "border-red-200 bg-red-50 text-red-700",
};
const LABEL = { chosen: "Chosen", available: "Also suitable", excluded: "Excluded" };

function CheckRow({ c, i }) {
  const note = (c.conflicts.length ? c.conflicts : c.cautions).join("; ");
  return (
    <li className={`rounded-lg border px-3 py-2 text-xs ${TONE[c.status]}`} data-testid={`rx-check-${c.class.toLowerCase()}-${i}`}>
      <span className={`font-semibold ${c.status === "excluded" ? "line-through" : ""}`}>{c.drug}</span> · {LABEL[c.status]}
      {note && <span className="block mt-0.5 text-slate-600">{note}</span>}
    </li>
  );
}

export function RxEscalation({ rx }) {
  if (!rx.escalation?.length) return null;
  return (
    <div className="mt-3 rounded-xl border-2 border-red-500 bg-red-50 p-3 text-sm text-red-800" data-testid="rx-no-safe-option">
      <p className="font-bold flex items-center gap-2"><ShieldAlert className="w-4 h-4" /> No safe standard option found</p>
      {rx.escalation.map((e) => <p key={e} className="mt-1">{e}</p>)}
    </div>
  );
}

export function RxCheck({ rx }) {
  if (!rx.checks?.length) return null;
  return (
    <details className="mt-3 group" data-testid="rx-check">
      <summary className="cursor-pointer text-xs font-semibold text-emerald-900 flex items-center gap-1.5" data-testid="rx-check-toggle">
        <ShieldCheck className="w-3.5 h-3.5" /> How these options were checked
      </summary>
      <p className="text-xs text-slate-600 mt-2">Each option was checked against every condition, medication and allergy recorded for this patient at the same time.</p>
      {["Antibiotic", "Analgesic"].map((cls) => (
        <div key={cls} className="mt-2">
          <p className="text-xs font-bold text-slate-700">{cls}</p>
          <ul className="mt-1 grid sm:grid-cols-2 gap-1.5">
            {rx.checks.filter((c) => c.class === cls).map((c, i) => <CheckRow key={c.drug} c={c} i={i} />)}
          </ul>
        </div>
      ))}
    </details>
  );
}
